var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEasyCrmSoloLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 91,
    viewBox: "0 0 92 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1597880216"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8391 0.239258H76.9438C80.8444 0.239258 84.5621 1.78095 87.3047 4.55599C90.0473 7.33103 91.571 11.0928 91.571 15.0395V75.2887C91.571 79.2354 90.0473 82.9971 87.3047 85.7722C84.5621 88.5472 80.8444 90.0889 76.9438 90.0889H14.8391C10.9385 90.0889 7.22078 88.5472 4.47818 85.7722C1.73558 82.9971 0.211914 79.2354 0.211914 75.2887V15.0395C0.211914 11.0928 1.73558 7.33103 4.47818 4.55599C7.22078 1.78095 10.9385 0.239258 14.8391 0.239258Z",
    fill: "#614EFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9222 18.5557L81.1476 18.7407C81.1476 18.7407 62.0713 44.826 81.3914 71.8364H67.7393C67.7393 71.8364 57.9879 63.3263 57.7441 46.1211C57.7441 46.1211 57.4394 29.1008 67.9222 18.5557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.2795 18.5557L57.5049 18.7407C57.5049 18.7407 38.3677 44.826 57.7487 71.8364H44.0967C44.0967 71.8364 34.3452 63.3263 34.1014 46.1211C34.0405 46.1211 33.7357 29.1008 44.2795 18.5557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5681 18.5557L33.7935 18.7407C33.7935 18.7407 14.6562 44.826 34.0373 71.8364H20.3243C20.3243 71.8364 10.5728 63.3263 10.329 46.1211C10.329 46.1211 10.0243 29.1008 20.5681 18.5557Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyCrmSoloLogo);
export default __webpack_public_path__ + "static/media/easyCRM-solo-logo.c74f70d24213ae5526da9aca7d818aff.svg";
export { ForwardRef as ReactComponent };